import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import RSVP from 'rsvp';

export default class DatasetsRoute extends Route 
{
	@service store;

	async model()
	{
		let datasets = await this.store.findAll('dataset');
		let sources = await this.store.findAll('source');
		let events = await this.store.findAll('event');
		
		//this forces the store to fetch each dataset by id so that the relationionships are loaded
		for(const dataset of datasets)
		{
			this.store.findRecord('dataset',dataset.id,{ reload: true });
		}
		
		return {
			datasets: datasets,
			sources: sources,
			events: events
		}
	}
}
